import React from "react";

import { ResourceAvatar } from "@common/resourceAvatar";
import { Checkbox } from "../../checkbox";
import { Props } from "./types";
import styles from "./styles.scss";

function Resource({ resource, isSelected, select, unSelect }: Props) {
  return (
    <div className={styles.resource} onClick={!isSelected ? select : unSelect}>
      <Checkbox isChecked={isSelected} />
      <div className={styles.icon}>
        <ResourceAvatar resource={resource} />
      </div>
      <div className={styles.col}>
        <p className={styles.name}>{resource.name}</p>
        {!!resource.profession && (
          <p className={styles.profession}>{resource.profession}</p>
        )}
      </div>
    </div>
  );
}

export { Resource };
